import { ResultOptions } from './TestCaseResult.enums';

export const ResultValueToLabel: { [key in ResultOptions]: string } = {
  passed: 'Passed',
  failed: 'Failed',
  blocked: 'Blocked',
};
